import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

// دالة لإزالة التكرارات بناءً على id (تُستخدم لاحقًا فقط إن احتجت لعرض خدمات فريدة)
const consolidateObjects = (items) => {
  const seen = new Set();
  return items.filter((item) => {
    if (seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
};

const MobileNav = () => {
  const location = useLocation();

  const [cartRawData, setCartRawData] = useState([]); // البيانات الأصلية من localStorage
  const [cartData, setCartData] = useState([]); // البيانات بعد إزالة التكرارات
  const cartDataRef = useRef(cartData);

  useEffect(() => {
    const existCart = JSON.parse(localStorage.getItem("cartItems")) ?? [];
    setCartRawData(existCart);
    const filteredData = consolidateObjects(existCart);
    setCartData(filteredData);
    cartDataRef.current = filteredData;
  }, []);

  useEffect(() => {
    const handleCartUpdate = (event) => {
      const updatedCart = event.detail.cart ?? [];
      setCartRawData(updatedCart);
      const filtered = consolidateObjects(updatedCart);
      setCartData(filtered);
      cartDataRef.current = filtered;
    };

    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
    };
  }, []);

  const navLinks = [
    { path: "/", label: "الرئيسية" },
    { path: "/whatwedo", label: "من نحن" },
    { path: "/blog", label: "المدونة" },
    { path: "/faq", label: "الأسئلة الشائعة" },
    { path: "/contacts", label: "تواصل معنا" },
  ];

  return (
    <div className="absolute z-50 w-full bg-white">
      <div className="flex flex-col gap-6 justify-center items-center mx-auto my-5 w-52">

        <a
          href="meting"
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-2 border rounded-lg text-[#3E4450] border-[#C8CBD3] w-full text-center font-medium"
        >
          احجز اجتماع
        </a>

        <a
          href="/services"
          className="px-4 py-2 border rounded-lg text-[#3E4450] border-[#C8CBD3] w-full text-center font-medium"
        >
          الخدمات
        </a>

        {navLinks.map((link) => (
          <a
            key={link.path}
            href={link.path}
            className={`hover:bg-[#ecedee] rounded-lg transition w-full text-center ${location.pathname === link.path
                ? "text-[#003E6F] font-bold"
                : "font-normal"
              }`}
          >
            {link.label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default MobileNav;
